import { useCallback, useRef, useState, type ReactNode, type Ref } from 'react'
import type { TextInput } from 'react-native'

export type TWithBrowserTextareaHeightProps = {
  onLayout: VoidFunction
  onValueUpdate: VoidFunction
}

export const withBrowserTextareaHeight =
  <Props extends TAnyProps>(
    Component: (props: Props & TWithBrowserTextareaHeightProps & { ref?: Ref<TextInput> }) => ReactNode,
  ) =>
  (props: Props) => {
    const ref = useRef<TextInput>(null)
    const [initialHeight, setInitialHeight] = useState<number>(0)

    const handleLayout = useCallback(() => {
      if (ref.current) {
        if (initialHeight === 0) {
          setInitialHeight(ref.current.scrollHeight)
          // @ts-expect-error - scrollHeight and style are not defined on type TextInput
          ref.current.style.minHeight = `${ref.current.scrollHeight}px`
        }
        // @ts-expect-error - style is not defined on type TextInput
        ref.current.style.height = '0px'
        // @ts-expect-error - scrollHeight and style are not defined on type TextInput
        ref.current.style.height = `${ref.current.scrollHeight}px`
      }
    }, [initialHeight, setInitialHeight])

    return <Component {...props} onLayout={handleLayout} ref={ref} onValueUpdate={handleLayout} />
  }
